import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../elements/Box';
import Col from '../../elements/Col';
import Row from '../../elements/Row';
import Text from '../../elements/Text';
import Icon from '../../elements/Icon';

const LegendCalendar = (props) => {
  const {
    legendPrice,
    showCurrenciesType,
    legendBlackOutDays,
    showLegendPrice,
    showLegendBlackOutDays,
    columnLegendPriceSetting,
    columnLegendBlackOutDaysSetting,
    columnCurrenciesTypeSetting,
    legendPriceBox,
    blackOutDaysPriceBox,
    legendCheckAvailability,
    legendCheckAvailabilityIcon,
    legendLowPriceText,
    showLowPriceText = false,
    isMobile
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Row ariaHidden={true} className={`${className} fr-clearfix`} style={style} dataTestId="legend">
      {showLegendPrice && (
        <Col style={{ display: 'flex' }} {...columnLegendPriceSetting}>
          <Box
            style={{
              background: 'blue',
              height: '15px',
              width: showLowPriceText ? '35px' : '15px'
            }}
            {...legendPriceBox}
          >
            {showLowPriceText && (
              <Text {...legendLowPriceText}>
                {translate('cmp-legend-lowest-price-small', 'Low')}
              </Text>
            )}
          </Box>
          <Text floatLeft marginRight="1" {...legendPrice}>
            {!isMobile
              ? translate('cmp-legend-lowest-price', 'Lowest fare')
              : translate('cmp-legend-lowest-price-mobile', 'Lowest fare match')}
          </Text>
        </Col>
      )}
      {showLegendBlackOutDays && (
        <Col style={{ display: 'flex' }} {...columnLegendBlackOutDaysSetting}>
          <Box
            style={{
              background: '#eeeeee',
              height: '15px',
              width: '15px'
            }}
            {...blackOutDaysPriceBox}
          ></Box>
          <Text {...legendBlackOutDays} floatLeft marginRight="1">
            {translate('cmp-legend-black-out-days', 'Black out days')}
          </Text>
        </Col>
      )}
      {showCurrenciesType && (
        <Col style={{ display: 'flex' }} {...columnCurrenciesTypeSetting}>
          <Icon ariaHidden={true} icon="searchV2" size="18" {...legendCheckAvailabilityIcon}></Icon>
          <Text {...legendCheckAvailability} floatLeft marginRight="1">
            {translate('cmp-legend-check-availabilty', 'Check Availabilty')}
          </Text>
        </Col>
      )}
    </Row>
  );
};

LegendCalendar.propTypes = {
  /**
   * Props of legendPrice
   */
  legendPrice: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of BlackOutDays
   */
  legendBlackOutDays: PropTypes.objectOf(PropTypes.any),
  /**
   * Props of CurrenciesType
   */
  legendCurrenciesType: PropTypes.objectOf(PropTypes.any),
  /**
   * Turn off or on the showLegendPrice item
   */
  showLegendPrice: PropTypes.bool,
  /**
   * Turn off or on the LegendBlackOutDays item
   */
  showLegendBlackOutDays: PropTypes.bool,
  /**
   * Turn off or on the CurrenciesType item
   */
  showCurrenciesType: PropTypes.bool
};

LegendCalendar.defaultProps = {
  legendPrice: {},
  legendBlackOutDays: {},
  legendCurrenciesType: {},
  showLegendPrice: true,
  showLegendBlackOutDays: true,
  showCurrenciesType: true
};

export default LegendCalendar;
